import {Component, OnInit} from '@angular/core';
import {CommonService} from "../../core/services/common.service";
import {AffiliateService} from "../../core/services/affiliate.service";

@Component({
  selector: 'app-earning',
  templateUrl: './earning.component.html',
  styleUrl: './earning.component.css'
})
export class EarningComponent implements OnInit {
   customer: any;userCode: string;
  constructor(private affiliateService: AffiliateService, private common: CommonService) {
    this.customer = this.common.getStorage('customer');
    this.userCode = this.customer.firstName.charAt(0).toUpperCase() +
    this.customer.lastName.charAt(0).toUpperCase();
  }

  stats = [
    { title: 'Total Earnings', value: '₹0', icon: 'wallet', color: 'danger' },
    { title: 'Amount Paid', value: '₹0', icon: 'currency-rupee', color: 'success' },
    { title: 'Pending Payout', value: '₹0', icon: 'clock', color: 'warning' },
    { title: 'Conversion Rate', value: '100%', icon: 'wallet-fill', color: 'primary' }
  ];

  payoutMethods = [
    { name: 'RazorPay', icon: 'razorpay', details: 'ravi.sharma@example.com' },
    { name: 'Bank Transfer', icon: 'university', details: 'HDFC Bank •••• 6789' },
    { name: 'UPI', icon: 'wallet', details: 'ravi.sharma@upi' }
  ];

  transactions = [
    {
      product: 'Samsung Galaxy S23',
      date: 'Aug 12, 2023',
      id: 'SS-042',
      amount: '₹1,250',
      icon: 'mobile-alt',
      status: 'paid'
    },
    {
      product: 'MacBook Air M2',
      date: 'Aug 10, 2023',
      id: 'SS-105',
      amount: '₹2,150',
      icon: 'laptop',
      status: 'paid'
    },
    {
      product: 'Sony Headphones',
      date: 'Aug 8, 2023',
      id: 'SS-089',
      amount: '₹450',
      icon: 'headphones',
      status: 'paid'
    },
    {
      product: 'iPad Pro',
      date: 'Aug 5, 2023',
      id: 'SI-045',
      amount: '₹1,100',
      icon: 'tablet-alt',
      status: 'pending'
    },
    {
      product: 'OnePlus 11 5G',
      date: 'Aug 2, 2023',
      id: 'SS-042',
      amount: '₹620',
      icon: 'mobile-alt',
      status: 'failed'
    }
  ];

  payoutHistory = [
    {
      title: 'July Payout',
      date: 'Aug 5, 2023',
      method: 'Bank Transfer',
      amount: '₹4,500',
      status: 'paid'
    },
    {
      title: 'August Payout',
      date: 'Processing',
      method: 'PayPal',
      amount: '₹2,250',
      status: 'pending'
    },
    {
      title: 'June Payout',
      date: 'Jun 15, 2023',
      method: 'UPI',
      amount: '₹3,800',
      status: 'failed'
    }
  ];

  ngOnInit() {
    this.getStatistics();
  }

  getStatistics() {
    this.affiliateService.getStatistics(this.customer.id).subscribe({
      next: (res) => {
        this.stats[0].value = '₹'+(res.response.affiliateEarnings.reduce((sum, r) => sum + (r.amount ?? 0), 0)).toFixed(2);
        this.stats[2].value = '₹'+(res.response.affiliateEarnings.reduce((sum, r) => sum + (r.amount ?? 0), 0)).toFixed(2);
      },
      error: (err) => {
        console.error("Error loading stats", err);
      }
    });
  };
}
